<template>
  <popup-bg :show-lock="showLock" v-if="financialForm.crm_id" :loading-lock="loadingLock">
    <div slot="custom-html">
      <div class="financial-wrap">
        <div class="financial-header">
          <div class="header-content">
            <span>合同编号</span>
            <span>{{ formData['contract_number'] }}</span>
          </div>
          <div class="header-content">
            <span>邀约方式</span>
            <span>{{ formData.order_method === 1 ? '支付邀约' : '财务报账' }}</span>
          </div>
          <div class="header-content">
            <span>学生姓名</span>
            <span>{{ formData['custom_name'] }}</span>
          </div>
          <div class="header-content">
            <span>入学时间</span>
            <span>{{ formData['custom_year'] }}</span>
          </div>
        </div>
        <div class="financial-form">
          <el-form :model="formData" :rules="rules" ref="validateForm" label-width="24%">
            <el-form-item label="产品名称">
              <el-col :span="24" class="ptb10">
                <el-select
                  placeholder="请选择"
                  clearable
                  v-model="formData['goods_id']"
                  filterable
                  @change="handelProduct"
                  :disabled="formData['goods_unchange'] === 1">
                  <el-option
                    v-for="item in formData.initForm['goods_name_list']"
                    :key="item.id"
                    :value="item.id"
                    :label="item.value"/>
                </el-select>
              </el-col>
              <el-col :span="24">
                <el-select
                  v-model="formData['goods_class']">
                  <el-option
                    v-for="item in productFirstData.initForm['goods_class_list']"
                    :key="item.id"
                    :value="item.id"
                    :label="item.value"/>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="服务合同金额" class="moreline">
              <el-input
                placeholder="请输入"
                v-model="formData['serve_money']"
                :disabled='serve_money_disabled'>
              </el-input>
            </el-form-item>
            <el-form-item label="实付金额">
              <el-input
                placeholder="请输入"
                v-model="formData['price']"
                :disabled="payAmountDisabled">
              </el-input>
            </el-form-item>
            <el-form-item label="付款方式">
              <el-select
                placeholder="请选择"
                clearable
                v-model="formData['payment_method']">
                <el-option
                  v-for="item in this.paymentMethodData"
                  :key="item.id"
                  :value="item.id"
                  :label="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="支付时间" v-if="formData.order_method === 1">
              <el-date-picker
                v-model="payTime1"
                type="datetime"
                :editable="false"
                @change="timeChange(1)"
                format="yyyy/MM/dd HH:mm:ss"
                placeholder="选择开始日期">
              </el-date-picker>
              <div class="ptb10"></div>
              <el-date-picker
                v-model="payTime2"
                type="datetime"
                :editable="false"
                @change="timeChange(2)"
                format="yyyy/MM/dd HH:mm:ss"
                placeholder="选择结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="所申学校">
              <jm-school-search
                clearable
                placeholder="如学生未确定学校无需填写"
                :country-id="formData['country']"
                v-model="tags"
                @change="paySelect"/>
            </el-form-item>
            <!--            <el-form-item label="交易凭证">-->
            <!--              <jm-upload-->
            <!--                class="upload-demo"-->
            <!--                action="/newfib.php/index/order/addPic"-->
            <!--                :on-preview="handlePreview"-->
            <!--                :on-success="handlePayUpload"-->
            <!--                :data="uploadPayData()"-->
            <!--                :on-remove="handlePayRemove"-->
            <!--                :file-list="formData['voucher_images']"-->
            <!--                multiple-->
            <!--                list-type="picture">-->
            <!--                <el-button-->
            <!--                  size="small"-->
            <!--                  type="primary">点击上传</el-button>-->
            <!--                <div-->
            <!--                  slot="tip"-->
            <!--                  class="el-upload__tip">只能上传jpg/png文件</div>-->
            <!--              </jm-upload>-->
            <!--              <el-dialog :visible.sync="dialogVisible">-->
            <!--                <img-->
            <!--                  width="100%"-->
            <!--                  height="100%"-->
            <!--                  :src="dialogImageUrl"-->
            <!--                  alt="">-->
            <!--              </el-dialog>-->
            <!--            </el-form-item>-->
            <el-form-item label="法务备注">
              <el-input
                type="textarea"
                autosize
                resize="none"
                v-model="formData['law_note_text']"
                placeholder="备注只会显示给法务，请填写纸质合同号">
              </el-input>
            </el-form-item>
            <el-form-item label="财务备注">
              <el-input
                v-model="formData['note_text']"
                type="textarea"
                autosize
                resize="none"
                placeholder="备注只会显示给财务，如用户使用银行转帐等其他付款方式或代签信息则备注在这里">
              </el-input>
            </el-form-item>
            <div class="bluefire-common-btnarea">
              <el-button @click="returnVisitSubmit" :loading="btnLock">确认添加</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="close-button">
      <slot name="close-button"></slot>
    </div>
  </popup-bg>
</template>

<script>
import popupBg from './popupBg';
import { jmSchoolSearch } from '@/components/tool';
import { isEmpty } from '@/utils/utils';
import { currentInterviewSchool } from '@/api/user';

let formData = {
  crmid: 0,
  goods_id: '',
  goods_class: '',
  serve_money: '',
  price: '',
  order_method: '',
  country: '',
  allograph: '',
  allograph_dept: '',
  payment_method: '',
  law_note_text: '',
  note_text: '',
  pay_time_range: '',
  initForm: {
    goods_name_list: [],
    allograph_list: [],
  },
  school_apply: [],
  contract_number: ''
};

export default {
  data () {
    return {
      btnLock: false,
      payTime1: '',
      payTime2: '',
      dialogImageUrl: '',
      dialogVisible: false,
      loadingLock: false,
      QualificationInput: false, // 是否禁止上传
      fileList: [{
        url: 'https://worker.doggadatachina.com/base/fus/files/uAGsD6BOyIIOz0qp0471K7cJ.png',
        contentType: 'image/png',
        name: '1540519646.png'
      }],
      formData: formData, // 实时表单数据
      originData: formData, // 原有表单数据
      productFirstData: { // 特殊产品名称 二级联动数据
        initForm: {
          goods_class_list: [],
        }
      },
      serve_money_disabled: false, // 合同金额是否禁用
      paymentMethodData: [],
      tags: '', // 申请学校数据
      rules: {
        order_method: [
          { required: true, message: '请选择邀约方式', trigger: 'change' },
        ],
        goods_id: [
          { required: true, message: '请输入产品名称', trigger: 'change' },
        ],
        serve_money: [
          { required: true, message: '请输入服务合同金额', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入实付金额，如不需要请填0', trigger: 'blur' }
        ],
        payment_method: [
          { required: true, message: '请选择付款方式', trigger: 'change' }
        ],
      }
    };
  },
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    financialForm: {
      type: Object,
      default() {
        return {
          crm_id: 0
        };
      }
    },
  },
  computed: {
    /**
     * Description: 实付金额 根据产品名称切换
     * Author: liushaochen <liushaochen@tuozhongedu.com>
     */
    payAmountDisabled() {
      if (this.formData.goods_id === this.goods_id_temporary &&
        this.formData.goods_class === this.goods_class_temporary) {
        if (this.formData.order_status && this.formData.order_status === 2) {
          return true;
        }
      } else {
        return false;
      }
    },
  },
  mounted() {
  },
  methods: {
    /**
     * Description: 操作select 重新赋值
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    paySelect(payObj) {
      if (payObj && this.formData.school_apply.indexOf(payObj.value) === -1) {
        this.formData.school_apply.push(payObj.value);
      }
    },
    // 时间选择规则
    timeChange: function(val) {
      if (this.payTime1 && this.payTime2 && this.payTime1 > this.payTime2) {
        this.$message.error('开始时间不得大于结束时间');
        if (val === 1) {
          this.payTime1 = '';
        } else {
          this.payTime2 = '';
        }
      }
    },
    /**
     * Description: 上传成功
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    // handlePayUpload(file) {
    //   if (file.result !== -1) {
    //     this.$message.success('上传成功');
    //     this.formData.voucher_images.push(file.data);
    //   } else {
    //     this.$message.error(file.msg);
    //   }
    // },
    /**
     * Description: 删除 上传图片
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handlePayRemove(file) {
      if (file.status === 'success') {
        let fileid = '';
        if (file.fid) {
          fileid = file.fid;
        } else {
          fileid = file.response.data.fid;
        }
        this.$http._get({
          url: '/index/order/delPic',
          data: {
            crmid: this.$route.params.crmid,
            contract: this.formData.contract_number,
            fileid,
          }
        }).then((data) => {
          this.$message.success(data.msg);
        });
      }
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      console.log(file);
    },
    /**
     * Description: 上传参数
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    uploadPayData() {
      return {
        crmid: this.formData.id,
        contract: this.formData.contract_number
      };
    },
    // 保存
    returnVisitSubmit: function() {
      if (this.formData.order_method === 1 && (!this.payTime1 || !this.payTime2)) {
        this.$message.error('请选择支付时间');
        return false;
      }
      this.$refs.validateForm.validate((valid) => {
        this.formData.action = this.financialForm.orderNum ? 'edit' : 'create';
        console.log(valid);
        if (valid) {
          this.btnLock = true;
          this.formData.pay_time_range[0] = this.payTime1;
          this.formData.pay_time_range[1] = this.payTime2;
          this.$http._post({
            url: '/index/order/save',
            data: this.formData,
          }).then((result) => {
            this.btnLock = false;
            console.log(result.msg);
            this.$message.success(result.msg);
            window.location.reload();
          }).catch(() => {
            this.btnLock = false;
          });
        } else {
          this.btnLock = false;
          return false;
        }
      });
    },
    // 初始化数据
    initData() {
      this.loadingLock = true;
      if (!this.financialForm.crm_id && (!this.financialForm.orderNum || [1, 2].indexOf(this.financialForm.type) === -1)) {
        console.log('缺少数据：', this.financialForm);
        this.$emit('update:showLock', false);
        return new Promise((resolve) => {
          resolve(null);
        });
      }
      let url = '';
      if (this.financialForm.orderNum) {
        url = `/index/order/info?crmid=${this.financialForm.crm_id}&orderNum=${this.financialForm.orderNum}`;
      } else {
        url = `/index/order/create?crmid=${this.financialForm.crm_id}&type=${this.financialForm.type}`;
      }

      return new Promise((resolve, reject) => {
        this.$http._get({
          url: url,
        }).then(({ data }) => {
          resolve(data);
        }).catch((data) => {
          reject(data);
        });
      });
    },
    /**
     * Description: 产品名称 联动请求
     * Author: liushaochen <liushaochen@tuozhongedu.com>
     */
    productFirst(value) {
      return new Promise((resolve) => {
        this.$http._get({
          url: `/index/order/goodsInfo/crmid/${this.financialForm.crm_id}?goods_id=${value}`,
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * Description: 一级联动 触发二级
     * Author: liushaochen <liushaochen@tuozhongedu.com>
     */
    handelProduct(value) {
      if (!value) {
        return false;
      }
      this.productFirst(value).then((data) => {
        let found = data.initForm.goods_class_list.find((item) => {
          return item.id === this.formData.goods_class;
        });
        if (!found) {
          this.formData.goods_class = null;
        }

        if (data.initForm.contract_number) {
          this.formData.contract_number = data.initForm.contract_number;
        }
        if (data.initForm.serve_money) {
          this.formData.serve_money = data.initForm.serve_money;
          this.serve_money_disabled = true;
        } else if (this.inited) {
          this.serve_money_disabled = false;
        }
        this.productFirstData = data;
        if (this.$route.name !== 'paymentedit') {
          this.formData.goods_class = data.initForm.goods_class_list[0] &&
            data.initForm.goods_class_list[0].id;
        }
        this.inited = true;
      });
    },
  },
  components: {
    'popup-bg': popupBg,
    jmSchoolSearch,
  },
  watch: {
    financialForm() {
      this.initData().then((data) => {
        if (data) {
          console.log('初始化数据');
          if (isEmpty(data.allograph) || data.allograph === 0) {
            data.allograph = '';
          }
          if (isEmpty(data.allograph_dept) || data.allograph_dept === 0) {
            data.allograph_dept = '';
          }
          if (isEmpty(data.payment_method) || data === 0) {
            data.payment_method = '';
          }
          if (isEmpty(data.goods_id) || data.goods_id === 0) {
            data.goods_id = '';
          }
          if (isEmpty(data.goods_class) || data.goods_class === 0) {
            data.goods_class = '';
          }
          this.payTime1 = data.time_start * 1000;
          this.payTime2 = data.time_expire * 1000;
          this.formData = Object.assign({}, formData, data);
          this.originData = this.formData;

          if (this.formData.order_method === 1) {
            this.paymentMethodData = this.formData.initForm.payment_method1;
          } else if (this.formData.order_method === 2) {
            this.paymentMethodData = this.formData.initForm.payment_method2;
          }

          // 如果有面试学校直接赋值
          currentInterviewSchool(this.financialForm.crm_id).then(({ data }) => {
            if (data) {
              this.tags = {
                sh_id: data.school_id,
                sh_name_cn: data.school_name,
                value: data.school_name,
              };
              this.formData.school_apply.push(data.school_name);
            }
          });
        }
        this.handelProduct(this.formData.goods_id);
        this.loadingLock = false;
      }).catch(({ data }) => {
        if (data.result < 0) {
          this.$emit('update:showLock', false);
        }
      });
    }
  }
};
</script>
<style>
  .financial-wrap .financial-form .el-form .el-form-item.moreline .el-form-item__label{
    line-height: 18px;
  }
  .el-time-panel{
    left: auto;
    right: 0;
  }
</style>
<style scoped>
  .financial-wrap .financial-header{
    background: #F4F7FE;
    padding: 5vw 2vw 3vw 4vw;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 4vw 4vw 0 0;
  }
  .financial-wrap .financial-header .header-content{
    width: 53%;
    display: inline-block;
  }
  .financial-wrap .financial-header .header-content:nth-of-type(2n){
    width: 47%;
  }
  .financial-wrap .financial-header .header-content span{
    font-size: 3.46vw;
    line-height: 7vw;
    color: #8992AF;
    display: inline-block;
    word-break: break-all;
    white-space: nowrap;
    vertical-align: text-top;
  }
  .financial-wrap .financial-header .header-content span:last-of-type{
    color: #333;
    margin-left: 2vw;
    white-space: normal;
    max-width: 60%;
  }
  .financial-wrap .financial-header .header-content:first-of-type span:last-of-type{
    color: #0496ff;
  }
  .financial-wrap .financial-form{
    padding: 0 4vw;
    max-height: 62vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .financial-wrap .financial-form .el-form{
    margin-top: 5vw;
  }
  .financial-wrap .financial-form .el-form .el-form-item{
    margin-bottom: 2vw;
  }
  .financial-wrap .financial-form .el-select{
    width: 100%;
  }
  .ptb10{
    padding-bottom: 2vw;
  }
  .financial-wrap .financial-form .el-form .el-form-item .el-date-editor, .financial-wrap .financial-form .el-form .el-form-item .el-autocomplete{
    width: 100%;
  }

</style>
